
// //src/Admin/CreateUser.component.jsx
// //This component will allow admin to create, delete, give permission to users.

import React, { useState } from "react";
import { createUser, setUserAccess } from "../service/User.service";
import DistrictBlockSchool from "../components/CentersOrSchools/DistrictBlockSchool.json";
import { Container, Form, Button, Row, Col, Card, Table } from "react-bootstrap";
import Select from "react-select";
import Papa from "papaparse";

export const CreateUser = () => {

  console.log(DistrictBlockSchool)

  const [userData, setUserData] = useState({
    userId: "",
    name: "",
    email: "",
    password: "",
    contact1: "",
    contact2: "",
    department: "",
    role: "",
    isActive: true,
  });

  const [modules, setModules] = useState([]);
  const [region, setRegion] = useState([]);
  // ✅ Changed from classIds to batches
  const [batches, setBatches] = useState([]);

  const [selectedDistricts, setSelectedDistricts] = useState([]);
  const [selectedBlocks, setSelectedBlocks] = useState([]);
  const [selectedSchools, setSelectedSchools] = useState([]);

  const departmentRoles = {
    Community: ["CC", "ACI", "Community Incharge", "Project Coordinator", "Community Manager", "Technician", "hkrn"],
    Academics: ["Academic Coordinator", "DTP", "Teacher"],
    Admin: ["Admin"],
    HR: ["HR Executive", "HR Manager"],
    Media: ["Media Manager", "Photographer"],
    Tech: ["MIS", "Data Analyst", "Tech Lead"],
    Accounts: ["Accountant"],
    HS100: ["hs100admin", "hs100 executive"],
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "department") {
      setUserData({ ...userData, department: value, role: "" });
    } else {
      setUserData({ ...userData, [name]: value });
    }
  };

  const addModule = () => {
    setModules([...modules, { name: "Academics", accessLevel: "read" }]);
  };

  const updateModule = (index, field, value) => {
    const updated = [...modules];
    updated[index][field] = value;
    setModules(updated);
  };

  const addRegion = () => {
    if (selectedDistricts.length === 0 || selectedBlocks.length === 0 || selectedSchools.length === 0) return;

    const newRegions = selectedDistricts.map((d) => ({
      districtId: d.value,
      blockIds: selectedBlocks.map((b) => ({
        blockId: b.value,
        schoolIds: selectedSchools.map((s) => ({ schoolId: s.value })),
      })),
    }));

    const mergedRegions = [...region];

    newRegions.forEach((newReg) => {
      const existingDistrict = mergedRegions.find((r) => r.districtId === newReg.districtId);

      if (existingDistrict) {
        // merge blocks
        newReg.blockIds.forEach((newBlock) => {
          const existingBlock = existingDistrict.blockIds.find((b) => b.blockId === newBlock.blockId);
          if (existingBlock) {
            // merge schools
            newBlock.schoolIds.forEach((s) => {
              if (!existingBlock.schoolIds.some((es) => es.schoolId === s.schoolId)) {
                existingBlock.schoolIds.push(s);
              }
            });
          } else {
            existingDistrict.blockIds.push(newBlock);
          }
        });
      } else {
        mergedRegions.push(newReg);
      }
    });

    setRegion(mergedRegions);
    setSelectedDistricts([]);
    setSelectedBlocks([]);
    setSelectedSchools([]);
  };

  // ✅ Updated to handle batches instead of classes
  const toggleBatch = (batch) => {
    if (batches.includes(batch)) {
      setBatches(batches.filter((b) => b !== batch));
    } else {
      setBatches([...batches, batch]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userRes = await createUser(userData);
      const user = userRes.data;

      const accessReq = {
        unqObjectId: user._id,
        userId: user.userId,
        modules,
        region,
        // ✅ Send batch instead of classId
        batch: batches,
      };

      console.log("Access Request:", accessReq);
      await setUserAccess(accessReq);

      alert("User and access created successfully!");
      setUserData({
        userId: "",
        name: "",
        email: "",
        password: "",
        contact1: "",
        contact2: "",
        department: "",
        role: "",
        isActive: true,
      });
      setModules([]);
      setRegion([]);
      setBatches([]);
    } catch (err) {
      console.error(err);
      alert("Error creating user or access");
    }
  };

  const districts = [
    ...new Map(DistrictBlockSchool.map((d) => [d.districtId, { value: d.districtId, label: d.districtName }])).values(),
  ];
  const blocks = DistrictBlockSchool.filter((d) => selectedDistricts.some((sd) => sd.value === d.districtId)).map((b) => ({
    value: b.blockId,
    label: b.blockName,
  }));
  const schools = DistrictBlockSchool.filter((d) => selectedBlocks.some((sb) => sb.value === d.blockId)).map((s) => ({
    value: s.schoolId,
    label: s.schoolName,
  }));

  const [assignAllDistricts, setAssignAllDistricts] = useState(false);
  const [assignFullDistricts, setAssignFullDistricts] = useState(false);

  const handleAssignAllDistricts = (checked) => {
    setAssignAllDistricts(checked);
    setAssignFullDistricts(false);
    if (checked) {
      const allRegions = districts.map((d) => ({
        districtId: d.value,
        blockIds: DistrictBlockSchool.filter((dbs) => dbs.districtId === d.value).map((b) => ({
          blockId: b.blockId,
          schoolIds: DistrictBlockSchool.filter((s) => s.blockId === b.blockId).map((s) => ({
            schoolId: s.schoolId,
          })),
        })),
      }));
      setRegion(allRegions);
    } else {
      setRegion([]);
    }
  };

  const handleAssignFullDistricts = (selected) => {
    setSelectedDistricts(selected);
    if (selected.length > 0) {
      const selectedRegions = selected.map((d) => ({
        districtId: d.value,
        blockIds: DistrictBlockSchool.filter((dbs) => dbs.districtId === d.value).map((b) => ({
          blockId: b.blockId,
          schoolIds: DistrictBlockSchool.filter((s) => s.blockId === b.blockId).map((s) => ({
            schoolId: s.schoolId,
          })),
        })),
      }));
      setRegion(selectedRegions);
    } else {
      setRegion([]);
    }
  };

  // ---------------------- BULK UPLOAD FUNCTIONS ----------------------

  // helper to merge regions
  const mergeRegions = (existingRegions, newRegions) => {
    const merged = [...existingRegions];
    newRegions.forEach((newReg) => {
      const existingDistrict = merged.find((r) => r.districtId === newReg.districtId);
      if (existingDistrict) {
        newReg.blockIds.forEach((newBlock) => {
          const existingBlock = existingDistrict.blockIds.find((b) => b.blockId === newBlock.blockId);
          if (existingBlock) {
            newBlock.schoolIds.forEach((s) => {
              if (!existingBlock.schoolIds.some((es) => es.schoolId === s.schoolId)) {
                existingBlock.schoolIds.push(s);
              }
            });
          } else {
            existingDistrict.blockIds.push(newBlock);
          }
        });
      } else {
        merged.push(newReg);
      }
    });
    return merged;
  };

  // Download CSV template with prefilled format
  const handleDownloadTemplate = () => {
    if (!userData.userId) {
      alert("Please fill user data to generate template");
      return;
    }

    const moduleNames = modules.map((m) => m.name).join(", ");
    const moduleRoles = modules.map((m) => m.accessLevel).join(", ");
    // ✅ Changed classStr to batchStr
    const batchStr = batches.join(",");

    let rows = [];

    region.forEach((r) => {
      r.blockIds.forEach((b) => {
        b.schoolIds.forEach((s) => {
          rows.push({
            userId: userData.userId,
            name: userData.name,
            email: userData.email,
            password: userData.password,
            contact1: userData.contact1,
            contact2: userData.contact2,
            dept: userData.department,
            role: userData.role,
            moduleaccess: moduleNames,
            accessRole: moduleRoles,
            district: r.districtId,
            block: b.blockId,
            school: s.schoolId,
            // ✅ Changed class to batch
            batch: batchStr,
          });
        });
      });
    });

    const csv = Papa.unparse(rows);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "bulk_user_template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Upload CSV and register users
  const handleUploadCSV = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      complete: async (result) => {
        const grouped = {};

        // group by userId
        result.data.forEach((row) => {
          if (!grouped[row.userId]) {
            grouped[row.userId] = { user: row, modules: [], regions: [], batches: [] };
          }

          // ✅ safe split
          const moduleAccess = row.moduleaccess ? row.moduleaccess.split(",") : [];
          const accessRoles = row.accessRole ? row.accessRole.split(",") : [];
          // ✅ Changed class to batch
          const batchList = row.batch ? row.batch.split(",") : [];

          grouped[row.userId].modules = moduleAccess.map((m, i) => ({
            name: m.trim(),
            accessLevel: accessRoles[i]?.trim() || "read",
          }));

          // ✅ Changed classes to batches
          grouped[row.userId].batches = batchList;

          const newRegion = {
            districtId: row.district,
            blockIds: [
              {
                blockId: row.block,
                schoolIds: [{ schoolId: row.school }],
              },
            ],
          };

          grouped[row.userId].regions = mergeRegions(grouped[row.userId].regions, [newRegion]);
        });

        // create users
        for (let uid in grouped) {
          const { user, modules, regions, batches } = grouped[uid];
          try {
            const userRes = await createUser({
              userId: user.userId,
              name: user.name,
              email: user.email,
              password: user.password,
              contact1: user.contact1,
              contact2: user.contact2,
              department: user.dept,
              role: user.role,
              isActive: true,
            });
            const createdUser = userRes.data;

            const accessReq = {
              unqObjectId: createdUser._id,
              userId: createdUser.userId,
              modules,
              region: regions,
              // ✅ Changed classId to batch
              batch: batches,
            };

            await setUserAccess(accessReq);
            console.log("Uploaded user:", createdUser.userId);
          } catch (err) {
            console.error("Error uploading user:", uid, err);
          }
        }

        alert("Bulk upload completed!");
      },
    });
  };

  // -------------------------------------------------------------------

  return (
    <Container className="my-4">
      <Card className="p-4 shadow-lg rounded-3">
        <h2>Add User</h2>
        <Form onSubmit={handleSubmit}>
          {/* ---- your existing form code unchanged ---- */}

          {/* User Info */}
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>User ID</Form.Label>
                <Form.Control
                  name="userId"
                  value={userData.userId}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  name="name"
                  value={userData.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={userData.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  value={userData.password}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Contact 1</Form.Label>
                <Form.Control
                  name="contact1"
                  value={userData.contact1}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Contact 2</Form.Label>
                <Form.Control
                  name="contact2"
                  value={userData.contact2}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Department & Role */}
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Department</Form.Label>
                <Form.Select
                  name="department"
                  value={userData.department}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Department</option>
                  {Object.keys(departmentRoles).map((dept) => (
                    <option key={dept} value={dept}>
                      {dept}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Role</Form.Label>
                <Form.Select
                  name="role"
                  value={userData.role}
                  onChange={handleChange}
                  required
                  disabled={!userData.department}
                >
                  <option value="">Select Role</option>
                  {userData.department &&
                    departmentRoles[userData.department]?.map((role) => (
                      <option key={role} value={role}>
                        {role}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          {/* Module Access */}
          <h5>Module Access</h5>
          {modules.map((mod, idx) => (
            <Row key={idx} className="mb-2">
              <Col md={6}>
                <Form.Select
                  value={mod.name}
                  onChange={(e) => updateModule(idx, "name", e.target.value)}
                >
                  <option value="Academics">Academics</option>
                  <option value="Bills">Bills</option>
                  <option value="Downloads">Downloads</option>
                  <option value="Callings">Callings</option>
                  <option value="TRUE">TRUE</option>
                </Form.Select>
              </Col>
              <Col md={6}>
                <Form.Select
                  value={mod.accessLevel}
                  onChange={(e) => updateModule(idx, "accessLevel", e.target.value)}
                >
                  <option value="read">Read</option>
                  <option value="create">Create</option>
                  <option value="write">Write</option>
                  <option value="delete">Delete</option>
                  <option value="admin">Admin</option>
                </Form.Select>
              </Col>
            </Row>
          ))}
          <Button variant="secondary" onClick={addModule} className="mb-3">
            + Add Module
          </Button>

          {/* Region Access */}
          <h5>Region Access</h5>

          <div className="mb-2">
            <Form.Check
              type="checkbox"
              label="Assign All Districts (all blocks & schools auto)"
              checked={assignAllDistricts}
              onChange={(e) => handleAssignAllDistricts(e.target.checked)}
            />
            <Form.Check
              type="checkbox"
              label="Assign District(s) Fully (auto all blocks & schools under them)"
              checked={assignFullDistricts}
              disabled={assignAllDistricts}
              onChange={(e) => {
                setAssignFullDistricts(e.target.checked);
                setAssignAllDistricts(false); // reset other mode
                setRegion([]); // reset region
              }}
            />
          </div>

          <Row className="mb-3">
            <Col md={4}>
              <Select
                isMulti
                value={selectedDistricts}
                onChange={(selected) =>
                  assignFullDistricts ? handleAssignFullDistricts(selected) : setSelectedDistricts(selected)
                }
                options={districts}
                placeholder="Select District(s)"
                isDisabled={assignAllDistricts}
              />
            </Col>
            <Col md={4}>
              <Select
                isMulti
                value={selectedBlocks}
                onChange={setSelectedBlocks}
                options={blocks}
                placeholder="Select Block(s)"
                isDisabled={assignAllDistricts || assignFullDistricts}
              />
            </Col>
            <Col md={4}>
              <Select
                isMulti
                value={selectedSchools}
                onChange={setSelectedSchools}
                options={schools}
                placeholder="Select School(s)"
                isDisabled={assignAllDistricts || assignFullDistricts}
              />
            </Col>
          </Row>

          {!assignAllDistricts && !assignFullDistricts && (
            <Button variant="secondary" onClick={addRegion} className="mb-3">
              + Add Region
            </Button>
          )}

          {region.length > 0 && (
            <Table striped bordered>
              <thead>
                <tr>
                  <th>District</th>
                  <th>Block</th>
                  <th>School</th>
                </tr>
              </thead>
              <tbody>
                {region.map((r, idx) =>
                  r.blockIds.map((b) =>
                    b.schoolIds.map((s) => (
                      <tr key={idx + s.schoolId}>
                        <td>{r.districtId}</td>
                        <td>{b.blockId}</td>
                        <td>{s.schoolId}</td>
                      </tr>
                    ))
                  )
                )}
              </tbody>
            </Table>
          )}

          {/* ✅ Batch Access (Replaced Class Access) */}
          <h5>Batch Access</h5>
          <div className="mb-3">
            {["2024-26", "2025-27", "2026-28", "2025-27 (HS100)-Boys", "2025-27 (HS100)-Girls", "2026-28 (HS100)-Boys", "2026-28 (HS100)-Girls"].map((batch) => (
              <Form.Check
                inline
                key={batch}
                label={batch}
                type="checkbox"
                checked={batches.includes(batch)}
                onChange={() => toggleBatch(batch)}
              />
            ))}
          </div>

          <Button type="submit" variant="primary">
            Save User
          </Button>
        </Form>

        {/* ---- NEW BUTTONS ---- */}
        <hr />
        <h5>Bulk Upload Options</h5>
        <Button variant="warning" className="me-3" onClick={handleDownloadTemplate}>
          Download Bulk Upload Format
        </Button>
        <Form.Group controlId="formFile" className="mt-3">
          <Form.Label>Upload CSV</Form.Label>
          <Form.Control type="file" accept=".csv" onChange={handleUploadCSV} />
        </Form.Group>
      </Card>
    </Container>
  );
};